import { render, staticRenderFns } from "./AppsList.vue?vue&type=template&id=3f48ac6c&"
import script from "./AppsList.vue?vue&type=script&lang=ts&"
export * from "./AppsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports